import * as Yup from "yup";

import { ETransactionType } from "./models";
import { IProductTransactionForm } from "./product_buy_transaction_entity";

export interface IProductSellBulkTransactionForm {
  clientId: string;
  productTransactions: IProductTransactionForm[];
  paidAmount: number;
  type: ETransactionType.PRODUCT_SELL;
}

const productSellTransactionCommonValidation = {
  clientId: Yup.string().required(),
  productTransactions: Yup.array<IProductTransactionForm>(
    Yup.object({
      productId: Yup.string().required(),
      dirtyWeight: Yup.number()
        .min(1)
        .required(),
      cleanWeight: Yup.number()
        .min(1)
        .required(),
      pricePerKg: Yup.number()
        .min(0)
        .required(),
      wastePercent: Yup.number()
        .min(0)
        .max(99)
        .required(),
      amount: Yup.number()
        .min(1)
        .required(),
    }),
  ),
  paidAmount: Yup.number()
    .min(0)
    .required(),
  type: Yup.mixed()
    .oneOf([ETransactionType.PRODUCT_SELL])
    .required(),
};

export const productSellTransactionFormValidation = Yup.object<IProductSellBulkTransactionForm>({
  ...productSellTransactionCommonValidation,
});

// export const transactionEditFormValidation = Yup.object<IProductTransactionForm>({
//   ...productTransactionCommonValidation,
// });

export const productSellTransactionToJson = (form: IProductSellBulkTransactionForm) => {
  const paid = [];

  const productTransactions = form.productTransactions.map((t) => {
    return {
      client: {
        id: form.clientId,
      },
      product: {
        id: t.productId,
      },
      dirtyWeight: parseFloat(t.dirtyWeight.toString()),
      wastePercent: parseFloat(t.wastePercent.toString()),
      amount: parseFloat(t.amount.toString()),
      type: ETransactionType.PRODUCT_SELL,
    };
  });

  if (form.paidAmount > 0) {
    paid.push({
      client: {
        id: form.clientId,
      },
      type: ETransactionType.RECIEVE,
      amount: parseFloat(form.paidAmount.toString()),
    });
  }

  return {
    bulk: [...productTransactions, ...paid],
  };
};
